<template>
  <div class="main">
    <div class="form-row">
      <div class="form-field">
        <b>Подпишите пользовательское соглашение</b>
        Вы как представитель компании, подписываете соглашение с ООО "5 AM" и
        соглашаетесь с правилами пользования платформы Lokeo
      </div>
      <div class="form-field">
        <button @click="confirmRules">Согласен</button>
      </div>
    </div>
    <div class="form-row" v-if="info">{{ info }}</div>
  </div>
</template>

<script>
import config from "@/config";
import { mapState } from "vuex";

export default {
  name: "Register",
  data() {
    return {
      url: config.backend_url,
      info: false
    };
  },
  computed: mapState({
    userId: state => state.user.profile.id
  }),
  methods: {
    confirmRules: function() {
      let self = this;
      let activateData = {};
      activateData.userId = this.userId;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "users/confirm-rules/",
          data: activateData
        })
        .then(function(response) {
          let data = response.data;

          if (data.response) {
            self.$store.commit("auth/confirmRules");
            self.$router.push("/");
          } else {
            self.info = data.success;
          }
        });
    }
  },
  mounted() {}
};
</script>
